import Model from '@/lib/data/Model';

class FormRow extends Model {
    fields = ['caption', 'value'];

    constructor(data) {
        super(data);
        this.init();
    }
}

export default FormRow;
